module.exports = __webpack_public_path__ + "img/trash_red.b101fa41.svg";